/**
 * Takes a snake_case string and returns a human readable string
 *
 * @param input - ie. some_string
 * @returns - ie. Some String
 */
export function snakeCaseToHumanReadable(input: string): string {
  if (typeof input !== 'string') {
    throw new Error('input must be a string');
  }
  const words = input.split('_');
  const formatted = [];
  for (const w of words) {
    formatted.push(w.charAt(0).toUpperCase() + w.slice(1));
  }
  return formatted.join(' ');
}

export const escapeRegExp = (string: string): string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

/**
 * Converts a string to kebab-case (lowercase words joined by hyphens).
 *
 * @param str - ie. "Multiple NSF Transactions"
 * @returns - ie. "multiple-nsf-transactions"
 */
export function toKebabCase(str: string): string {
  return str.toLowerCase().replace(/\s+/g, '-');
}
